import React from "react";

const isActivePath = (currentPath, itemPath, match = "exact") => {
  if (!itemPath) return false;
  if (match === "prefix") return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);
  return currentPath === itemPath;
};

const SidebarNav = ({ sections, currentPath, onNavigate }) => {
  return (
    <nav className="sidebar-nav" aria-label="Sidebar Navigation">
      {sections
        .filter((section) => section.items?.some((it) => !it.hidden))
        .map((section) => (
          <div key={section.title} className="nav-section">
            <div className="nav-section-title">{section.title}</div>
            <ul className="nav-list">
              {section.items
                .filter((it) => !it.hidden)
                .map((item) => (
                  <li
                    key={item.path}
                    className={`nav-item ${
                      isActivePath(currentPath, item.path, item.match) ? "active" : ""
                    }`}
                    onClick={() => {
                      if (item.external) {
                        window.open(item.path, "_blank", "noopener,noreferrer");
                      } else {
                        onNavigate(item.path);
                      }
                    }}
                    role="button"
                    tabIndex={0}
                    aria-current={
                      isActivePath(currentPath, item.path, item.match) ? "page" : undefined
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        if (item.external) {
                          window.open(item.path, "_blank", "noopener,noreferrer");
                        } else {
                          onNavigate(item.path);
                        }
                      }
                    }}
                  >
                    {item.label}
                    {item.external && (
                      <span style={{ marginLeft: 6, fontSize: "0.75em", opacity: 0.6 }}>↗</span>
                    )}
                  </li>
                ))}
            </ul>
          </div>
        ))}
    </nav>
  );
};

export default SidebarNav;

